import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BreakpointServiceInjector } from '@next/core-lib/responsive';
import { map, take } from 'rxjs/operators';

export const deviceRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const breakpoint = inject(BreakpointServiceInjector);

  return breakpoint.ltMd$.pipe(
    take(1),
    map((isMobile) => {
      if (isMobile) {
        return router.createUrlTree(['/']);
      }

      return true;
    }),
  );
};
